import { Fragment } from "react";
import { Link } from "react-router-dom";

// Minimal markdown: ## / ### headings, "- " lists, paragraphs, **bold**, [text](url).
export function inline(text, key) {
  const parts = [];
  const re = /(\*\*([^*]+)\*\*)|(\[([^\]]+)\]\(([^)]+)\))/g;
  let last = 0;
  let m;
  while ((m = re.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[2]) parts.push(<strong key={`${key}-${m.index}`} className="font-semibold text-[var(--parchment)]">{m[2]}</strong>);
    else if (m[5].startsWith("/")) parts.push(<Link key={`${key}-${m.index}`} to={m[5]} className="text-[var(--gold-soft)] underline underline-offset-4 hover:text-[var(--gold)]">{m[4]}</Link>);
    else parts.push(<a key={`${key}-${m.index}`} href={m[5]} target="_blank" rel="noopener noreferrer" className="text-[var(--gold-soft)] underline underline-offset-4">{m[4]}</a>);
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}

export function RichText({ source }) {
  const blocks = String(source || "").replace(/\r/g, "").split(/\n\s*\n/).map((b) => b.trim()).filter(Boolean);
  return (
    <div data-testid="rich-text" className="space-y-5 text-base leading-relaxed text-[var(--parchment)]/85">
      {blocks.map((b, i) => {
        if (b.startsWith("### ")) return <h3 key={i} className="pt-2 font-display text-2xl italic text-[var(--gold-soft)]">{inline(b.slice(4), i)}</h3>;
        if (b.startsWith("## ")) return <h2 key={i} className="pt-6 font-display text-3xl sm:text-4xl">{inline(b.slice(3), i)}</h2>;
        if (b.split("\n").every((l) => /^(- |\d+\. )/.test(l))) {
          const ordered = /^\d+\. /.test(b);
          const Tag = ordered ? "ol" : "ul";
          return (
            <Tag key={i} className={`space-y-2 pl-6 ${ordered ? "list-decimal" : "list-disc"} marker:text-[var(--gold)]`}>
              {b.split("\n").map((l, j) => <li key={j}>{inline(l.replace(/^(- |\d+\. )/, ""), `${i}-${j}`)}</li>)}
            </Tag>
          );
        }
        return <p key={i}>{b.split("\n").map((l, j) => <Fragment key={j}>{j ? <br /> : null}{inline(l, `${i}-${j}`)}</Fragment>)}</p>;
      })}
    </div>
  );
}
